export default{
    
    lista:{
        method:'get',
        url:'cargohoraria/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'cargohoraria/cadastro'
    },
    delete:{
        method:'delete',
        url:'cargohoraria/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'cargohoraria/editar{/id}'
    },
    update:{
        method:'post',
        url:'cargohoraria/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    },
    // pesquisa:{
    //     method:'get',
    //     url:'cargohoraria/busca{/id}'
    // }
}